import { schema } from "normalizr";
import { InventorySchema } from "./inventory";

export const InventoriesSchema = new schema.Array(InventorySchema);
